/**
 * Sometimes the client wants to insert text in a different language to the page, e.g. a heading in
 * English to a page that is in Finnish.
 *
 * To take care of the proper language attributes for such content, we instruct clients to add a
 * class in the "Additional CSS classes" section in the block editor.
 *
 * This code implements changing the `lang` -attribute of such elements to the target language.
 */
(() => {
    function changeLangAttributes(key, code) {
        let elements = document.querySelectorAll('.js-in-' + key);

        if (!elements.length) {
            return;
        }

        elements.forEach((element) => {
            element.setAttribute('lang', code);
        });
    }

    changeLangAttributes('english', 'en');
    changeLangAttributes('finnish', 'fi');
    changeLangAttributes('swedish', 'sv');
})();
